import React, {Component} from 'react';
import {Bold, ButtonStyle} from '../../Styles';
import styled from 'styled-components';
import moment from 'moment';
import { Loader } from "../../Shared";

const Icon = styled.button`
  color: #8290a2;
  border-color: #8290a2;
  text-align: center;
  float: right;
  border-radius: 7px;
  margin-left: 4px;
  margin-top: 5px;
  padding: 2px 7px 1px;
`;

const HiddenRow = styled.tr`
  td {
      padding: 0 !important;
  }
`;

const Resumes = props => {
  let resumes = [];
  var index = 0;
  props.resumes.forEach((resume) => {
    let target = 'resume' + index;
    resumes.push(<ResumeRow resume={resume} target={target} key={index++} {...props}/>)
    if (props.expandedRows.includes(target)) {
      resumes.push(<ResumeContent content={resume.content} key={index++}/>)
    }
  })
  return <tbody>{resumes}</tbody>;
}

const ResumeContent = (props) =>
  <HiddenRow>
    <td colSpan="4">
      <div style={{padding: "70px 50px", background: '#5f5f5f2e'}}>
        <div style={{padding: 80, background: '#fff'}} dangerouslySetInnerHTML={{ __html: props.content }}/>
      </div>
    </td>
  </HiddenRow>

const ResumeRow = (props) =>
  <tr>
    <td style={{paddingTop: 15}}>
      <Bold onClick={() => props.handleRowClick(props.target)}>{props.resume.name}</Bold>
    </td>
    <td style={{paddingTop: 15}} className="hidden-xs">
      <i className="fa fa-calendar" />&nbsp;{moment(props.resume.updated_at).format('MM-DD-YYYY')}
    </td>
    <td>
      <div>
        <Icon className="btn_status" alt="trash" onClick={() => props.confirm(props.resume)}>
          <i className="fa fa-trash" />
        </Icon>
        <Icon className="btn btn_status" alt="view" onClick={() => props.handleRowClick(props.target)}>
          <i className="fa fa-search" />
        </Icon>
      </div>
    </td>
  </tr>

export default class ResumeTable extends Component {
  constructor() {
    super();
    this.state = { expandedRows: [] };
  }

  handleRowClick = (rowId) => {
    const currentExpandedRows = this.state.expandedRows;
    const isRowCurrentlyExpanded = currentExpandedRows.includes(rowId);

    const newExpandedRows = isRowCurrentlyExpanded
      ? currentExpandedRows.filter((id) => id !== rowId)
      : currentExpandedRows.concat(rowId);

    this.setState({ expandedRows: newExpandedRows });
  };

  render() {
    const { resumePending } = this.props;
    return (
      <table
        className="table table-condensed"
        style={{ borderCollapse: "collapse" }}
      >
        <thead>
          <tr>
            <th className="bdl_radius" width="30%">
              Title
            </th>
            <th width="3%" className="hidden-xs">
              Last Updated
            </th>
            <th width="5%" className="hidden-xs"></th>
            <th width="20%" className="visible-xs"></th>
          </tr>
        </thead>
        <Loader show={resumePending} fullScreen vwidth="50%" />
        <Resumes
          {...this.props}
          expandedRows={this.state.expandedRows}
          handleRowClick={this.handleRowClick}
        />
      </table>
    );
  }
}
